var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"root-link",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/error-404.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }